
import { useEffect, useState } from "react";
import { expertiseGridClassName } from "../expertiseGrid";
import Expertise from "./Expertise";

export default function ExpertiseSelector({ expertises, initActiveExpertiseIds, onChange, isDesktop }) {
	const [activeExpertiseIds, setActiveExpertiseIds] = useState(initActiveExpertiseIds || []);

	useEffect(() => {
		setActiveExpertiseIds(initActiveExpertiseIds || []);
	}, [initActiveExpertiseIds]);

	const handleExpertiseChange = (expertiseId) => {
		let isAlreadyActive = activeExpertiseIds.includes(expertiseId);
		let newActiveExpertiseIds = [];
		if (isAlreadyActive) {
			newActiveExpertiseIds = activeExpertiseIds.filter((id) => id !== expertiseId);
		} else {
			newActiveExpertiseIds = [...activeExpertiseIds, expertiseId];
		}
		setActiveExpertiseIds(newActiveExpertiseIds);
		onChange(newActiveExpertiseIds);
	}

	return (
		<div className={expertiseGridClassName(isDesktop)}>
			{expertises.map((expertise, index) => (
				<Expertise
					key={expertise.id}
					expertise={expertise}
					isDesktop={isDesktop}
					index={index}
					isActive={activeExpertiseIds.includes(expertise.id)}
					onClick={handleExpertiseChange}
				/>
			))}
		</div>
	)
}
